import { Folder } from '@model/folder';
import { Mutate } from '@model/mutate';
import { Router } from '@angular/router';
import { Customer } from '@model/customer';
import { Globals } from '@theme/utils/globals';
import { environment } from '@env/environment';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FolderTerminate } from '@model/folder-terminate';
import { PaymentCustomer } from '@model/payment-customer';
import { FilterService } from '@service/filter/filter.service';
import { FolderService } from '@service/folder/folder.service';
import { MutateService } from '@service/mutate/mutate.service';
import { CustomerService } from '@service/customer/customer.service';
import { CustomerAddComponent } from '@client/customer/customer-add/customer-add.component';
import { PaymentCustomerService } from '@service/payment-customer/payment-customer.service';
import { FolderTerminateService } from '@service/folder-terminate/folder-terminate.service';
import { InvoiceFolder } from '@model/invoice-folder';
import { InvoiceFolderService } from '@service/invoice-folder/invoice-folder.service';
import { InvoiceFacService } from '@service/invoice/invoiceFac.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { UploaderService } from '@service/uploader/uploader.service';
import { ActivityService } from '@service/activity/activity.service';
import { RendService } from '@service/rdv/rend.service';
import { InventoryService } from '@service/inventory/inventory.service';
import { Inventory } from '@model/inventory';
import { WalletTransactionComponent } from '@client/wallet-transaction/wallet-transaction.component';
import { EmitterService } from '@service/emitter/emitter.service';

@Component({
  selector: 'app-customer-show',
  templateUrl: './customer-show.component.html',
  styleUrls: ['./customer-show.component.scss']
})
export class CustomerShowComponent implements OnInit {
  publicLink = environment.publicUrl;
  public activeTab: string = 'WALLET';
  publicUrl = environment.publicUrl;
  global = {country: Globals.country, device: Globals.device}
  userSession = Globals.user;
  filter: any;
  customer: Customer;
  client: boolean = false;
  name: boolean = false;
  folders: Folder[] =[];
  facturesA: any[] =[];
  echeances: any[] =[];
  invoices: InvoiceFolder[] =[];
  terminates: FolderTerminate[] =[];
  mutates: Mutate[] =[];
  payments: PaymentCustomer[] = [];
  inventories: any[] = [];
  type: string = 'WALLET';
  etatRow = [
    { label: 'Actif', value: 'ACTIF' },
    { label: 'Inactif', value: 'INACTIF' }
  ]
  typeRow = [
    { label: 'Client', value: 'CLIENT' },
    { label: 'Dossier', value: 'DOSSIER' },
    { label: 'État des lieux', value: 'ETAT' },
    { label: 'Facture', value: 'FACTURE' },
    { label: 'Paiement', value: 'PAIEMENT' },
    { label: 'Mutation', value: 'MUTATION' },
    { label: 'Résiliation', value: 'RESILIATION' }
  ]
  categorieRow = [
    {label: 'Particulier', value: 'PARTICULIER'},
    {label: 'Entreprise', value: 'ENTREPRISE'}
  ];
  nameTitle: string = "Client"
  userTitle: string = "Crée par"
  minTitle: string = "Montant MIN"
  maxTitle: string = "Montant MAX"
  categorieTitle: string = "Type de bien"
  etatTitle: string = "Disponibilité ?"
  file: any;
  rdvs = []
  notes = []
  dtOptions: any = {};

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private rdvService: RendService,
    private uploader: UploaderService,
    private folderService: FolderService,
    private mutateService: MutateService,
    private filterService: FilterService,
    private customerService: CustomerService,
    private activityService: ActivityService,
    private inventoryService: InventoryService,
    private invoiceService: InvoiceFolderService,
    private facturesService: InvoiceFacService,
    private terminateService: FolderTerminateService,
    private permissionsService: NgxPermissionsService,
    private paymentCustomerService: PaymentCustomerService,
    private emitter: EmitterService
  ) {
    this.customer = this.customerService.getCustomer();
    const permission = JSON.parse(localStorage.getItem('permission-zen')) ? JSON.parse(localStorage.getItem('permission-zen')) : [];
    this.permissionsService.loadPermissions(permission);
    this.onChangeLoad(this.type);
  }

  ngOnInit(): void {
  }

  onFilter($event) {
    this.folders = []
    this.mutates = []
    this.payments = []
    this.invoices = []
    this.terminates = []
    this.inventories = [];
    this.facturesA = [];
    $event.type = this.activeTab
    this.filterService.search($event, 'customer', this.customer.uuid).subscribe(
      res => {
      if(this.activeTab === 'CLIENT'){
        return this.customer = res;
      } else if(this.activeTab === 'DOSSIER'){
        return this.folders = res;
      } else if(this.activeTab === 'PAIEMENT'){
        return this.payments = res;
      } else if(this.activeTab === 'FACTURE'){
        return this.invoices = res;
      } else if(this.activeTab === 'MUTATION'){
        return this.mutates = res;
      } else if(this.activeTab === 'RESILIATION'){
        return this.terminates = res;
      }else if(this.activeTab === 'ECHEANCE'){
        return this.echeances = res;
      } else if (this.activeTab === 'ETAT') {
        return this.inventories = res;
      }  else if (this.activeTab === 'FACTURE_A') {
        return this.facturesA = res;
      } 
    }, err => { })
  }

  onChangeLoad(type): void {
    this.activeTab = type;
    if(type === 'CLIENT'){
      if(!this.customer){
        this.customerService.getSingle(this.route.snapshot.params.id).subscribe((res: any) => {
          if (res) { return this.customer = res; }
        });
      }
    } else if(type === 'DOSSIER'){
      this.typeRow = [{label: 'Dossier', value: 'DOSSIER'}];
      this.folderService.getList(this.customer.uuid, null).subscribe((res) => {
        return this.folders = res;
        }, error => {}
      );
      // this.nameTitle = "Client"
      this.name= false
      this.etatTitle = 'État'
      this.etatRow = [
        {label: 'Valide', value: 'VALIDE'},
        {label: 'Invalide', value: 'INVALIDE'}
      ]
      this.categorieTitle = 'Type'
      this.categorieRow = []
    } else if(type === 'FACTURE'){
      this.typeRow = [{label: 'Facture', value: 'FACTURE'}];
      this.invoiceService.getList(null, null, null, this.customer.uuid).subscribe((res) => {
        return this.invoices = res;
        }, error => {}
      );
      this.name= false
      this.etatTitle = 'État'
      this.etatRow = [
        {label: 'Impayé', value: 'IMPAYE'},
        {label: 'Attente', value: 'ATTENTE'},
        {label: 'En cours', value: 'EN COURS'},
        {label: 'Soldé', value: 'SOLDE'}
      ]
      this.categorieTitle = 'Type'
      this.categorieRow = []
    } else if(type === 'PAIEMENT') {
      this.name= true
      this.typeRow = [{label: 'Paiement', value: 'PAIEMENT'}];
      this.paymentCustomerService.getList(this.customer.uuid).subscribe((res) => {
        return this.payments = res;
        }, error => {}
      );
      this.etatTitle = 'État'
      this.nameTitle = 'N°dossier'
      this.etatRow = [
        {label: 'Valide', value: 'VALIDE'},
        {label: 'Invalide', value: 'INVALIDE'}
      ]
      this.categorieTitle = 'Type facture'
      this.categorieRow = []
    } else if(type === 'MUTATION'){
      this.name= true
      this.typeRow = [{label: 'Mutation', value: 'MUTATION'}];
      this.mutateService.getList(this.customer.uuid).subscribe((res) => {
        return this.mutates = res;
        }, error => {}
      );
      this.nameTitle = 'N°dossier'
      this.etatTitle = 'État'
      this.etatRow = [
        {label: 'Valide', value: 'VALIDE'},
        {label: 'Invalide', value: 'INVALIDE'}
      ];
      this.categorieRow = [];
    } else if(type === 'RESILIATION') {
      this.name= true
      this.typeRow = [{label: 'Résiliation', value: 'RESILIATION'}];
      this.terminateService.getList(this.customer.uuid, null).subscribe((res) => {
        return this.terminates = res;
        }, error => {}
      );
      this.nameTitle = 'N°dossier'
      this.etatTitle = 'État'
      this.etatRow = [
        {label: 'Valide', value: 'VALIDE'},
        {label: 'Invalide', value: 'INVALIDE'}
      ];
      this.categorieRow = [];
    } else if (type === 'NOTE_INTERNE'){
      this.activityService.getList(null, null, null, this.customer.uuid).subscribe((res: any) => {
        return this.notes = res
      })
      this.rdvService.getList(null, null, null, this.customer.uuid).subscribe((res: any) => {
        return this.rdvs = res
      })
    }else if (type === 'ECHEANCE'){
      this.typeRow = [{label: 'Echeance', value: 'ECHEANCE'}];
      this.folderService.getListEcheance(this.customer.uuid, null).subscribe((res) => {
        return this.echeances = res;
        }, error => {}
      );
    } else if (type === 'ETAT') {
      this.typeRow = [{label: 'ETATS DES LIEUX', value: 'ETAT'}];
      console.log(this.customer.uuid)
      this.inventoryService.getListCustomer(this.customer.uuid).subscribe(res => { return this.inventories = res; }, error => { });
      this.name= false
      this.etatTitle = 'État'
      this.etatRow = [
        {label: 'Valide', value: 'VALIDE'},
        {label: 'Invalide', value: 'INVALIDE'}
      ]
      this.categorieTitle = 'Type'
      this.categorieRow = []
    } else if (type === 'FACTURE_A'){
      this.typeRow = [{label: 'Autres factures', value: 'FACTURE_A'}];
      this.facturesService.getListCustomer(this.customer.uuid, null).subscribe((res) => {
        console.log(this.facturesA)
        return this.facturesA = res;
        }, error => {}
      );
    } 
  }
  editCustomer(row) {
    this.customerService.setCustomer(row)
    this.customerService.edit = true
    this.customerService.type = row.type
    this.modal(CustomerAddComponent, 'modal-basic-title', 'xl', true, 'static')
  }
  printerCustomer(row): void {
    this.customerService.getPrinter('SHOW', this.userSession?.agencyKey, this.userSession?.uuid, row?.uuid);
  }
  printerEcheance(row): void {
    this.folderService.getPrinterEcheance('SHOW', this.userSession?.agencyKey, this.userSession?.uuid, row?.uuid);
  }
  delete(item) {
    Swal.fire({
      title: '',
      text: 'Voulez-vous vraiment supprimer cet enrégistrement ?',
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Supprimer <i class="feather icon-trash"></i>',
      confirmButtonColor: '#d33',
      timer: 2500,
      reverseButtons: true
    }).then((willDelete) => {
      if (willDelete.dismiss) { } else {
        this.customerService.getDelete(item.uuid).subscribe((res: any) => {
          if (res?.status === 'success') {
            this.router.navigate(['/admin/client'])
            Swal.fire('', 'La suppression a été éffectuée avec succès !', 'success');
          }
        });
      }
    });
  }
  modal(component, type, size, center, backdrop) {
    this.modalService.open(component, {
      ariaLabelledBy: type,
      size: size,
      centered: center,
      backdrop: backdrop
    }).result.then((result) => { }, (reason) => { });
  }
  backCustomer(){ this.router.navigate(['/admin/client']) }
  showFile(item) {
    const fileByFolder = this.uploader.getDataFileByFolder();
    this.file = fileByFolder?.path ? this.publicUrl + '/' + fileByFolder?.path : null;
  }
  closeViewer() {
    this.file = '';
    this.uploader.setDataFileByFolder('');
  }

  /**
   * Ouvrir le modal de transaction wallet
   */
  addWalletTransaction(): void {
    this.customerService.setCustomer(this.customer);
    const modalRef = this.modalService.open(WalletTransactionComponent, {
      ariaLabelledBy: 'modal-wallet-transaction-title',
      size: 'lg',
      centered: true,
      backdrop: 'static'
    });

    modalRef.result.then(
      (result) => {
        if (result === 'success') {
          // Émettre un événement pour rafraîchir les composants wallet
          this.emitter.emit({
            action: 'WALLET_TRANSACTION',
            payload: { customerUuid: this.customer.uuid }
          });
        }
      },
      (dismissed) => {
        // Modal fermé sans action
      }
    );
  }
}
